import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const HeroSection = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    minHeight: '100vh',
    display: 'flex',
    position: 'relative',
    overflow: 'hidden',
}));

export const TextSection = styled(Box)(({ theme }) => ({
    width: '40%',
    position: 'relative',
    zIndex: 2,
    padding: '120px 0',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    alignItems: 'center',
}));

export const VideoSection = styled(Box)({
    width: '60%',
    position: 'absolute',
    right: 0,
    top: 0,
    height: '100%',
    zIndex: 1,
    overflow: 'hidden',
});

export const VideoBackground = styled(Box)({
    width: '100%',
    height: '100%',
    '& video': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(2px)',
    }
});

export const AboutSection = styled(Box)(({ theme }) => ({
    padding: '100px 0',
    minHeight: '80vh',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: theme.palette.mode === 'dark' 
            ? 'linear-gradient(135deg, rgba(25, 118, 210, 0.05) 0%, rgba(25, 118, 210, 0.1) 100%)'
            : 'linear-gradient(135deg, rgba(25, 118, 210, 0.03) 0%, rgba(25, 118, 210, 0.08) 100%)',
        zIndex: 0,
    },
    '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: theme.palette.mode === 'dark'
            ? 'radial-gradient(circle at 50% 50%, rgba(25, 118, 210, 0.1) 0%, transparent 50%)'
            : 'radial-gradient(circle at 50% 50%, rgba(25, 118, 210, 0.05) 0%, transparent 50%)',
        zIndex: 0,
    },
    '& > *': {
        position: 'relative',
        zIndex: 1,
    }
}));

export const ProfileImage = styled('img')({
    width: '100%',
    maxWidth: '400px',
    height: '500px',
    objectFit: 'cover',
    borderRadius: '20px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s ease',
    '&:hover': {
        transform: 'scale(1.02)',
    }
}); 